import { Box } from '@chakra-ui/react';
import React from 'react';

import { TextField } from 'Containers/App/types';
import { getCoverageDisclaimerKey } from 'Containers/App/utils';
import InfoBar from 'DesignLibrary/molecules/InfoBar';
import Text from 'Shared/Text';

export interface CoverageDisclaimerProps {
  planTypeName: string;
  maxChildAge: string | undefined;
  availableToSpouse: boolean;
  availableToChildren: boolean;
  availableToPartner: boolean;
}

export const CoverageDisclaimer = (props: CoverageDisclaimerProps) => {
  const { planTypeName, maxChildAge, availableToSpouse, availableToChildren, availableToPartner } = props;

  if (availableToChildren && maxChildAge === undefined) {
    return null;
  }

  const prefix = 'benefits_section_additional';
  const result = getCoverageDisclaimerKey({
    availableToSpouse,
    availableToPartner,
    availableToChildren,
    prefix,
  });

  if (result === '') {
    return null;
  }

  return (
    <Box mb={4}>
      <InfoBar
        color="yellow"
        icon="Warning"
        text={<Text field={result as TextField} vars={{ maxAge: maxChildAge, plan: planTypeName }} />}
      />
    </Box>
  );
};
